export const apiConstants = {
  cacheTime: 60 * 20 // 20 minutes
}
